<ng-template #content_raw_inventory_config let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.product_config">
        <div class="side_popup_header">
            <span>{{localService.languageContent.product_config.raw_inventory}}</span>
            <span>&nbsp;-&nbsp;{{productCode}}&nbsp;-&nbsp;{{productName}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
    </div>
    <div class="side_popup_body" style="margin: 10px;padding: 10px;height: calc(100vh - 10px);">
        <div>
            <label style="font-weight: normal; margin-left: 15px;">
                <input type="checkbox" [(ngModel)]="isRawInventoryEnabled"
                    (change)="onActiveInactiveFor(productId,ActiveInactiveFor.RawInventoryForProduct)" />
                <span
                    class="normal_color">{{localService.languageContent.product_config.is_enable_raw_inventory}}</span>
            </label>
        </div>
        <div *ngIf="isRawInventoryEnabled">
            <div class="row">
                <div class="col-12">
                    <app-label [Text]="productName" [IsColonRequired]="false" />
                    <span>-&nbsp;1&nbsp;{{localService.getText(localService.measurementTypes,measurementType)}}&nbsp;=&nbsp;</span>
                </div>
            </div>
            <div class="box" style="margin-bottom: 25px;">
                <div class="row">
                    <div>
                        <app-label [Text]="localService.languageContent.product_config.search_product" />
                    </div>
                    <div class="col-2">
                        <app-spinner *ngIf="isShowSpinnerCount > 0" />
                    </div>
                    <div class="col-10">
                        <ngx-select id="{{elementIds.product_dd}}"
                            placeholder="{{localService.languageContent.product_config.product_header}}"
                            title="{{localService.languageContent.product_config.product_header}}"
                            (typed)="onSearch($event)" [items]="searchItems" [optionValueField]="'key'"
                            [optionTextField]="'v3'" [allowClear]="true" [(ngModel)]="rawProductId"
                            (select)="onSetRawProduct()">
                            <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
                                <div class="row" title="{{option.data.v1}}">
                                    <div class="col-12">
                                        <div>
                                            <span class="en">{{option.data.v5}}&nbsp;-&nbsp;</span>
                                            <span
                                                [ngClass]="localService.getLanguageCode(option.data.v2)">{{option.data.v1}}</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </ngx-select>
                    </div>
                </div>
                <div class="row">
                    <div>
                        <app-label [Text]="localService.languageContent.product_config.deduct_qty" />
                        <span
                            *ngIf="rawProductId && rawMeasurementType">&nbsp;({{localService.getText(localService.measurementTypes,rawMeasurementType)}})</span>
                    </div>
                    <div class="col-2">
                        &nbsp;
                    </div>
                    <div class="col-6">
                        <input autocomplete="off" type="number" class="number" id="{{elementIds.qty}}"
                            (keypress)="localService.isNumberOnly($event,numericConfig)" [(ngModel)]="deductQty"
                            style="width:100%;text-align: left;"
                            placeholder="{{localService.languageContent.product_config.qty}}"
                            title="{{localService.languageContent.product_config.qty}}"
                            [ngClass]="deductQty ? 'en' : ''" (keydown.enter)="onSave()" />
                    </div>
                    <div class="col-4">
                        <button class="btn btn-primary" style="width:100%;" (click)="onSave()"
                            [disabled]="!deductQty || !rawProductId"
                            id="{{elementIds.btn_add}}">{{localService.languageContent.common.add}}</button>
                    </div>
                </div>
            </div>
            <div class="banner" *ngFor="let item of items" style="margin: 5px;">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <span class="en">&nbsp;{{item.v5}}&nbsp;-&nbsp;</span>
                            <app-label [Text]="item.v3" [IsColonRequired]="false" />
                        </div>
                        <div>
                            <button class="button_icon delete icon_adjust"
                                (click)="onActiveInactiveFor(item.key,ActiveInactiveFor.DeleteRawInventoryForProduct)"
                                title="{{localService.languageContent.common.delete}}">
                                add_circle_outline
                            </button>
                            <app-label [Text]="localService.languageContent.product_config.qty" />
                            <span class="en">{{item.v2}}&nbsp;-&nbsp;</span>
                            <span>{{localService.getText(localService.measurementTypes,item.v4)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>